import { useEffect, useState } from 'react';
import { SessionStorageKeys, getSession, setSession } from '@jbhi-fi/utils/src/sessionStorage/sessionStorage';

export const useSearchTooltip = (shouldShow = true, dismissDelay: number) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!shouldShow) return;

    const hasShown = getSession(SessionStorageKeys.SearchTooltipShown);
    if (hasShown === 'true') return;

    setVisible(true);
    setSession(SessionStorageKeys.SearchTooltipShown, 'true');

    const timer = setTimeout(() => {
      setVisible(false);
    }, dismissDelay);

    return () => clearTimeout(timer);
  }, [shouldShow, dismissDelay]);

  return visible;
};
